import React, { ReactNode, ReactNodeArray } from 'react'
import EpiComponent from '@episerver/spa-core/EpiComponent'
import FlowToEntityPaymentBlockData from '../../../Models/Content/FlowToEntityPaymentBlockData'
import FlowToEntityPayment from './FlowToEntityPayment';
import './FlowToEntityPayment.scss';
import { isMobile } from "react-device-detect";

export default class FlowToEntityPaymentBlock extends EpiComponent<FlowToEntityPaymentBlockData> {
    public render(): null | ReactNode | ReactNodeArray {
        let cssClasses: Array<string> = ['flow-to-entity-payment-container'];
        if (isMobile) cssClasses.push("isMobile");

        const FlowComponent = FlowToEntityPayment as any; // Type workaround for connected component

        return (
            <div className={cssClasses.join(' ')}>
                <FlowComponent cmsData={this.props.data} context={this.getContext()} />
            </div>
        )
    }
}
